import { render, staticRenderFns } from "./BasicList.vue?vue&type=template&id=0da386c0&scoped=true"
import script from "./BasicList.vue?vue&type=script&lang=js"
export * from "./BasicList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da386c0",
  null
  
)

export default component.exports